import {computed} from 'vue';
import {useRoute} from '#imports';

const MOBILE_APP_QUERY_PARAM = 'mobile_app';

export function useMobileApp() {
    const route = useRoute();

    const isMobileApp = computed(() => route.query[MOBILE_APP_QUERY_PARAM] === 'true');

    function withMobileAppParam(path: string, params?: URLSearchParams) {
        const searchParams = new URLSearchParams(params);
        if (isMobileApp.value) {
            searchParams.set(MOBILE_APP_QUERY_PARAM, 'true');
        }

        const query = searchParams.toString();
        return query ? `${path}?${query}` : path;
    }

    return {
        isMobileApp,
        withMobileAppParam,
    };
}
